export enum OpoCaseStatus {
    Pending = 1,
    Completed = 2,
    Cancelled = 3
}

export const OpoCaseStatusDescription = {
    [OpoCaseStatus.Pending]: 'Pending',
    [OpoCaseStatus.Completed]: 'Completed',
    [OpoCaseStatus.Cancelled]: 'Cancelled'
};

export const OpoCaseLateralities = ['L', 'R', 'en bloc'];

export interface IOpoCaseRequest {
    caseNumber: string,
    unosId: string,
    originCenterId: number | null,
    intendedCenterId: number | null,
    actualCenterId: number | null,
    scheduledPickupDateTime: string | null,
    scheduledDeliveryDateTime: string | null,
    actualPickupDateTime: string | null,
    actualDeliveryDateTime: string | null,
    statusId: OpoCaseStatus,
    gpsNumber: string,
    gpsLink: string,
    laterality: string,
    recipientCenterPocId: number | null,
    recipientPocName: string,
    recipientPocEmail: string,
    recipientPocPhone: string
}

export interface IOpoCase extends IOpoCaseRequest {
    id: number,
    originCenterAlias: string,
    intendedCenterAlias: string,
    actualCenterAlias: string,
    wentToIntendedCenter: boolean
}

export interface IOpoCaseCenter {
    id: number,
    alias: string,
    name: string,
    unosId: string,
    needsGpsServices: boolean
}

export interface IOpoRecipientCenterPoc {
    id: number,
    name: string,
    email: string,
    phone: string
}
